import type { ProductKeys3P } from '@atlassian/rovo-connectors-config/types';

import {
	FULL_CONNECTOR_SOURCE,
	type ThirdPartyConfigsBootstrap,
} from '../constants/schemas/3p-config';

/**
 * Returns whether the product has an admin-configured full connector with impersonation enabled.
 * Datasources are authoritative because product-level fields can be overwritten when several
 * SharePoint connector types are merged under the same product key.
 */
export const hasImpersonatedFullConnector = (
	productKey: string,
	thirdPartyConfigs: ThirdPartyConfigsBootstrap,
): boolean => {
	const productConfig = thirdPartyConfigs[productKey as ProductKeys3P];
	return Boolean(
		productConfig?.connectorSources?.includes(FULL_CONNECTOR_SOURCE) &&
		productConfig.datasources?.some((datasource) => datasource?.impersonationEnabled === true),
	);
};
